export const validationErrorToolMessage = (toolMessage: any, results: any) => {
    const content = [{
        type: 'text',
        text: results.errorMessage
    }];

    return {...toolMessage, content};
}